(() => {
  const form = document.getElementById('cs-builder-form');
  if (form) {
    const result = document.getElementById('cs-builder-result');
    const roundUp = (value, step) => Math.ceil(value / step) * step;
    form.addEventListener('change', () => {
      form.querySelector('input[type="checkbox"]').setCustomValidity('');
      result.hidden = true;
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const voltage = Number(document.getElementById('cs-voltage').value || 12);
      const days = Number(document.getElementById('cs-days').value || 1);
      let dailyWh = 0;
      let acPeak = 0;
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        dailyWh += Number(input.dataset.wh || 0);
        acPeak = Math.max(acPeak, Number(input.dataset.ac || 0));
      });
      if (dailyWh < 1) {
        const input = form.querySelector('input[type="checkbox"]');
        input.setCustomValidity(form.dataset.empty);
        input.reportValidity();
        input.addEventListener('change', () => input.setCustomValidity(''), {once:true});
        result.hidden = true;
        return;
      }
      form.querySelector('input[type="checkbox"]').setCustomValidity('');
      const bankAhRaw = (dailyWh * days) / (voltage * 0.80 * 0.85);
      const batteryAh = Math.max(voltage === 12 ? 100 : 50, roundUp(bankAhRaw, voltage === 12 ? 50 : 25));
      const solarW = Math.max(100, roundUp(dailyWh / (3 * 0.75), 50));
      let dcDc = batteryAh > 220 ? 50 : batteryAh > 120 ? 30 : 20;
      let inverter = acPeak > 1400 ? form.dataset.inverterLarge : acPeak > 0 ? form.dataset.inverterSmall : form.dataset.noInverter;
      document.getElementById('cs-result-wh').textContent = Math.round(dailyWh) + ' Wh';
      document.getElementById('cs-result-ah').textContent = batteryAh + ' Ah / ' + voltage + ' V';
      document.getElementById('cs-result-solar').textContent = solarW + ' W';
      document.getElementById('cs-result-dcdc').textContent = dcDc + ' A';
      document.getElementById('cs-result-inverter').textContent = inverter;
      result.hidden = false;
      const summary = form.dataset.summary.replace('{ah}', batteryAh).replace('{voltage}', voltage).replace('{days}', days);
      document.getElementById('cs-result-summary').textContent = summary;
      const help = document.getElementById('cs-result-help');
      const choices = [...form.querySelectorAll('input[type="checkbox"]:checked')].map(input => input.closest('label').querySelector('b').textContent.trim());
      const details = [...result.querySelectorAll('.cs-result-grid > div')].map(item => item.textContent.trim());
      help.href = 'mailto:info@camperstroem.dk?subject=' + encodeURIComponent(help.dataset.subject) + '&body=' + encodeURIComponent(summary + '\n\n' + choices.join(', ') + '\n\n' + details.join('\n'));
      result.focus({preventScroll:true});
      result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'nearest'});
    });
  }
  const marineWords = ['bådstørrelse','bådtype','boat size','boat type','sejlbåd','motorbåd'];
  document.querySelectorAll('facets-form details, .facets__disclosure, .filter-group, details').forEach((group) => {
    const txt = (group.querySelector('summary, legend, h3, .facets__summary')?.textContent || '').trim().toLowerCase();
    if (marineWords.some((word) => txt.includes(word))) group.style.display = 'none';
  });
})();

(() => {
  document.querySelectorAll('[data-cs-kit]').forEach((form) => {
    const card = form.closest('.cs-package');
    const buttons = card.querySelectorAll('[data-cs-kit-button]');
    const status = document.getElementById(form.id + '-status');
    const checkCart = card.querySelector('.cs-kit-cart-check');
    const items = [...form.querySelectorAll('[data-cs-item]')].map(input => ({id:input.value, quantity:Number(input.dataset.quantity)}));
    if (!items.length || items.some(item => !/^\d+$/.test(item.id) || !Number.isInteger(item.quantity) || item.quantity < 1)) return;
    buttons.forEach(button => { button.disabled = false; });
    let submitted = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitted) return;
      submitted = true;
      buttons.forEach(button => { button.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      status.textContent = form.dataset.pending;
      try {
        const response = await fetch(form.action + '.js', {
          method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({items}), credentials:'same-origin'
        });
        const body = await response.json();
        if (!response.ok || body.status >= 400 || !Array.isArray(body.items)) throw new Error('Cart addition was not confirmed');
        window.location.assign(form.dataset.cartUrl);
      } catch {
        const popover = card.querySelector('[popover]');
        if (popover && popover.matches(':popover-open')) popover.hidePopover();
        status.textContent = form.dataset.error;
        checkCart.hidden = false;
        status.focus({preventScroll:true});
        status.scrollIntoView({behavior:'auto',block:'nearest'});
      } finally {
        form.removeAttribute('aria-busy');
      }
    });
  });
})();
